document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-video').forEach((el) => {
        el.addEventListener('click', () => {
            if (el.classList.contains('is-loaded')) return;

            let url = el.dataset.video;
            if (!url) return;

            url += url.includes('?') ? '&autoplay=1' : '?autoplay=1';

            el.classList.add('is-loaded');

            el.innerHTML = `
                <iframe
                    src="${url}"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    allowfullscreen
                ></iframe>
            `;
        });
    });
});